import {clickEvent, customEvent} from "../../../webpack/modules/events";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";
import {post} from "../../../webpack/modules/ajax";
import {hideImageSliderLoader, showImageSliderLoader} from "../../../webpack/modules-optimized/product-page";
import {createModalFromHtml, showModal} from "../../../webpack/modules-optimized/modal";

let arToolReady = false;
clickEvent('#product-page .open-ar-tool', false, async function(element) {
    if (arToolReady) {
        showModal('ar-modal');
        return;
    }

    let productId = element.closest('#product-page').dataset.productId;

    showImageSliderLoader();
    await loadModal(productId);
    await loadScript();
    checkARCompatibility();
    showModal('ar-modal');
    hideImageSliderLoader();
    arToolReady = true;
});

customEvent('show.bs.modal', '#ar-modal', false, function() {
    ga4TrackSimpleEvent({
        "event": 'augmented_reality',
        "method": 'open_popup'
    });
});

customEvent('hide.bs.modal', '#ar-modal', false, function() {
    ga4TrackSimpleEvent({
        "event": 'augmented_reality',
        "method": 'close_popup'
    });
});

clickEvent('#model-viewer', false, function() {
    ga4TrackSimpleEvent({
        "event": 'augmented_reality',
        "method": 'open_camera'
    });
});

customEvent('ar-status', '#model-viewer', false, function(element, event) {
    if (event.detail.status === 'failed') {
        document.querySelector('#model-viewer').classList.add('d-none');
        document.querySelector('#ar-text').classList.add('d-none');
        document.querySelector("#ar-error").classList.remove('d-none');
        ga4TrackSimpleEvent({
            "event": 'augmented_reality',
            "method": 'not_available'
        });
    }
});

function loadModal(productId)
{
    return new Promise(resolve => {
        post(
            '/ajax/website/product/get-ar-tool-modal',
            {
                productId: productId,
            },
            function (response) {
                createModalFromHtml(response.modal);
                resolve();
            },
        );
    });
}

function loadScript()
{
    return new Promise(resolve => {
        let script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
        document.head.appendChild(script);

        script.onload = function () {
            resolve();
        };
    });
}

function checkARCompatibility()
{
    let modelViewer = document.querySelector('#model-viewer');
    let text = document.querySelector('#ar-text');
    let error = document.querySelector('#ar-error');
    if (!modelViewer.canActivateAR) {
        modelViewer.classList.add('d-none');
        text.classList.add('d-none');
        error.classList.remove('d-none');
        ga4TrackSimpleEvent({
            "event": 'augmented_reality',
            "method": 'not_available'
        });
    }
}